import React from 'react'
import './App.css'

import NotesForm from './Components/NotesForm';
import AllNotes from './Components/AllNotes';

function App() {
  return (
    <>
      <div className='heading'><h1><b>What's on your Mind ?</b></h1></div>
    <div className="container">
      <div className='form'>
        <NotesForm/>
      </div>
     <div className='notes'>
        <h4 className='notes-heading'><b>Your Notes...</b></h4>
        <AllNotes/>
     </div>
     
    </div>
    </>
  
  );
}

export default App;
